import styled from 'styled-components'

export const Thead = styled.thead`
  border-bottom: 2px solid #9e9e9e;
`

export const StatusTd = styled.td`
  width: 150px;
`

export const AgeTd = styled.td`
  width: 180px;
`
